/**
 * API Configuration
 * Centralized API URL configuration for the application
 * Uses environment variables for deployment flexibility
 */

import logger from '../utils/logger';

// Check if we're in development mode
const isDev = process.env.REACT_APP_DEV_MODE === 'true';

// SSR: Backend ve frontend aynı domain'de!
// API route'ları /api/* altında
const raw = isDev ? 'http://localhost:5000' : window.location.origin;
const API_BASE_URL = raw.replace(/\/+$/, '');

logger.log('API Config - Dev Mode:', isDev, '| API URL:', API_BASE_URL);

export default API_BASE_URL;
